import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { getUserDetail } from "../store/actions/users/users.actions";

export const useFeatureAccess = (requiredFeature) => {
  const { user: profile } = useSelector((state) => state.userDetails);
  const { user: auth } = useSelector((state) => state.auth);

  const profileFeatures = profile?.features || [];
  const authFeatures = auth?.features || [];
  const combinedFeatures = [...new Set([...profileFeatures, ...authFeatures])];

  const history = useNavigate();
  const { free_mode_count } = useSelector((state) => state.userFreeModeCount);
  const { free_mode_sqft_count } = useSelector((state) => state.userFreeModeSqFtCount);

  let hasFeatureAccess;
  hasFeatureAccess = combinedFeatures?.includes(requiredFeature) || (free_mode_count < 10 && requiredFeature !== "ITB Import");

  let hasSqftFeatureAccess = combinedFeatures?.includes(requiredFeature) || free_mode_sqft_count < 20;

  const enforceAccess = () => {
    if (!hasFeatureAccess || free_mode_count > 10 || free_mode_sqft_count >= 20) {
      history("/pricing");
    }
  };
  // console.log(
  //   "hasFeatureAccess",
  //   hasFeatureAccess,
  //   free_mode_count,
  //   " user?.features.includes(requiredFeature) ",
  //   user?.features.includes(requiredFeature),
  //   "requiredFeature",
  //   requiredFeature,
  //   "user?.features",
  //   user
  // );

  return { hasFeatureAccess, enforceAccess, hasSqftFeatureAccess };
};
